import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spin, message } from 'antd';
import { UserOutlined, DollarOutlined, LineChartOutlined } from '@ant-design/icons';
import './style.css';

interface StatisticsData {
  totalUsers: number;
  totalPaidUsers: number;
  todayNewUsers: number;
  todayNewPaidUsers: number;
  totalIncome: number;
  todayIncome: number;
  weekNewUsers: number;
  weekNewPaidUsers: number;
  weekIncome: number;
}

const Statistics: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<StatisticsData | null>(null);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const response = await fetch('https://api.wangdaodao.cn/api/admin/user/statistics');
      const result = await response.json();

      if (result.success) {
        setData(result.data);
      } else {
        message.error('获取统计数据失败');
      }
    } catch (error) {
      console.error('Failed to fetch statistics:', error);
      message.error('获取统计数据失败，请检查网络连接');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="statistics-container">
      <h1>数据统计</h1>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={8}>
          <Card className="stat-card">
            <div className="stat-header">
              <UserOutlined className="stat-icon" />
              <span>用户统计</span>
            </div>
            <div className="stat-content">
              <div className="stat-item">
                <span>总用户数：</span>
                <span className="stat-value">{data?.totalUsers}</span>
              </div>
              <div className="stat-item">
                <span>总付费用户：</span>
                <span className="stat-value">{data?.totalPaidUsers}</span>
              </div>
              <div className="stat-item">
                <span>今日新用户：</span>
                <span className="stat-value">{data?.todayNewUsers}</span>
              </div>
              <div className="stat-item">
                <span>今日新付费用户：</span>
                <span className="stat-value">{data?.todayNewPaidUsers}</span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Card className="stat-card">
            <div className="stat-header">
              <DollarOutlined className="stat-icon" />
              <span>收入统计</span>
            </div>
            <div className="stat-content">
              <div className="stat-item">
                <span>总收入：</span>
                <span className="stat-value">¥{data?.totalIncome}</span>
              </div>
              <div className="stat-item">
                <span>今日收入：</span>
                <span className="stat-value">¥{data?.todayIncome}</span>
              </div>
              <div className="stat-item">
                <span>本周收入：</span>
                <span className="stat-value">¥{data?.weekIncome}</span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Card className="stat-card">
            <div className="stat-header">
              <LineChartOutlined className="stat-icon" />
              <span>本周统计</span>
            </div>
            <div className="stat-content">
              <div className="stat-item">
                <span>本周新用户：</span>
                <span className="stat-value">{data?.weekNewUsers}</span>
              </div>
              <div className="stat-item">
                <span>本周新付费用户：</span>
                <span className="stat-value">{data?.weekNewPaidUsers}</span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Statistics;
